import { onReady } from '../lib/on-ready.js';
import { scrollIntoViewWithOffset } from '../lib/scroll-offset.js';

function initAnchorLinks() {
    document.querySelectorAll('.anchor-link').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
            event.preventDefault();
            scrollIntoViewWithOffset(anchor.dataset.anchor, 100);
        });
    });
}

onReady(initAnchorLinks);
